import classNames from 'classnames';
import { type IntlShape } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import type { JSX } from 'react';
import InstagramIcon from '../../socialIcons/InstagramIcon';
import TikTokIcon from '../../socialIcons/TikTokIcon';
import FacebookIcon from '../../socialIcons/FacebookIcon';
import TwitterIcon from '../../socialIcons/TwitterIcon';
import LinkedInIcon from '../../socialIcons/LinkedInIcon';
import styles from './styles.module.scss';

interface Props {
  intl: IntlShape;
  noFollowSocials?: boolean;
}

const ConnectWithUs = ({ noFollowSocials = true, intl }: Props): JSX.Element => (
  <>
    <Typography className={styles.title} component="h2" mt="0" variant="text300bold" color="inverse" data-testid="connect-with-us">
      {intl.formatMessage({ defaultMessage: 'Connect with us' })}
    </Typography>
    <div className={styles.socialIcons}>
      <InstagramIcon className={classNames(styles.iconClass, styles.hoverClass)} noFollowSocials={noFollowSocials} />
      <TikTokIcon className={classNames(styles.iconClass, styles.hoverClass)} noFollowSocials={noFollowSocials} />
      <FacebookIcon className={classNames(styles.iconClass, styles.hoverClass)} noFollowSocials={noFollowSocials} />
      <TwitterIcon className={classNames(styles.iconClass, styles.hoverClass)} noFollowSocials={noFollowSocials} />
      <LinkedInIcon className={classNames(styles.iconClass, styles.hoverClass)} noFollowSocials={noFollowSocials} />
    </div>
  </>
);

export default ConnectWithUs;
